export const fileToDataUrl = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result as string);
      } else {
        reject(new Error("File reading failed"));
      }
    };
    reader.onerror = () => {
      reject(new Error("File reading failed"));
    };
    reader.readAsDataURL(file);
  });
};

export const filesToDataUrls = async (files: File[]): Promise<string[]> => {
  try {
    if (files.length === 0) {
      return [];
    }

    const fileUrls = await Promise.all(
      files.map((file) => fileToDataUrl(file))
    );
    return fileUrls;
  } catch (error) {
    console.error("Error reading files:", error);
    throw error;
  }
};
